<template>
  <div class="py-10 bg_poster">
    <div style="margin:0 10%;">
      <h1>
        Poster and Oral Presentation
        <v-btn class="ml-5 mt-0" color="#636262" text fab @click="openSetting()" v-if="mode">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </h1>
      <!-- <pre>{{all_poster}}</pre> -->
      <!-- <pre>{{year_list}}</pre> -->
      <v-card color="primary" class="mt-3" tile style="height:8px; width:150px;"></v-card>
      <v-container fluid>
        <v-row>
          <v-col cols="4" v-for="(poster,index) in all_poster" :key="index">
            <v-row>
              <v-col cols="12" class="py-0">
                <v-card
                  class="mx-auto"
                  max-width="400"
                  min-height="600"
                  style="border-radius: 4px 4px 0 0;"
                >
                  <span v-if="poster.image.length == 0">
                    <v-img
                      class="white--text align-end"
                      height="300px"
                      :src="require('@/assets/no-img.svg')"
                    />
                    <v-divider></v-divider>
                  </span>
                  <v-carousel
                    :cycle="false"
                    :hide-delimiters="poster.image.length <= 1"
                    :show-arrows="false"
                    height="300px"
                    v-else
                  >
                    <v-carousel-item
                      v-for="(img_slide, index) in poster.image.slice(0,5) "
                      :key="index"
                      :src="env + img_slide.poster_file_path"
                    ></v-carousel-item>
                  </v-carousel>
                  <v-card-title>{{poster.poster_name.length > 100?poster.poster_name.substring(0,100) + '...' : poster.poster_name}}</v-card-title>
                  <v-card-subtitle class="pb-0">
                    <div style="font-size:16px;">เผยแพร่เมื่อปี : {{poster.poster_year + 543}}</div>
                    <div
                      style="font-size:16px;"
                      v-if="poster.image.length > 0"
                    >รูปภาพทั้งหมด {{poster.image.length}} รูป</div>
                    <div v-else>ไม่รูปภาพ</div>
                  </v-card-subtitle>
                  <v-card-text class="text--primary">
                    <v-tooltip bottom max-width="250">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          style="height:100px;font-size:16px;"
                        >{{poster.poster_details.length > 100?poster.poster_details.substring(0,100) + '...' : poster.poster_details}}</div>
                      </template>
                      <span style="font-size:16px;">{{poster.poster_details}}</span>
                    </v-tooltip>
                  </v-card-text>
                  <!-- <v-card-actions class="float-bottom">
                <v-spacer></v-spacer>
                <v-btn color="primaty" text @click="showMultiple(poster)">ดูรูปภาพ</v-btn>
                <v-spacer></v-spacer>
                  </v-card-actions>-->
                </v-card>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-card
                  max-width="400"
                  style="border-radius: 0 0 4px 4px;box-shadow: 0px 3px 0px -2px rgba(0, 0, 0, 0.2), 0px 2px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 0px 0px rgba(0, 0, 0, 0.12)"
                >
                  <center>
                    <v-btn color="primaty" block text @click="showMultiple(poster)">ดูรูปภาพ</v-btn>
                  </center>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <VueEasyLightbox :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></VueEasyLightbox>
      <!-- <pre>{{imgs}}</pre> -->
    </div>
    <DialogPoster ref="dialog_poster" @getPoster="getPoster()"></DialogPoster>
  </div>
</template>
<script>
import VueEasyLightbox from "vue-easy-lightbox";
import DialogPoster from "../Settings/DialogPoster.vue";
export default {
  components: {
    VueEasyLightbox,
    DialogPoster,
  },
  data() {
    return {
      mode: false,
      env: process.env.VUE_APP_API,
      all_poster: [],
      now_year: "",
      year_list: [],
      imgs: [],
      index: 0,
      visible: false,
    };
  },
  created() {
    this.mode = this.$session.get("token")
      ? this.$session.get("permission") == "admin"
      : false;
    this.getPoster();
    let date = new Date();
    this.now_year = date.getFullYear();
  },
  methods: {
    openSetting() {
      this.$refs.dialog_poster.openSetting();
    },
    getCategory() {
      this.all_poster.forEach((element) => {
        if (!this.year_list.includes(element.poster_year)) {
          this.year_list.push(element.poster_year);
        }
      });
      this.year_list.sort().reverse();
      // console.log(this.year_list);
    },
    getPoster() {
      let poster = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/poster/")
        .then((response) => {
          // console.log(response.data);
          poster = response.data;
          this.all_poster = poster;
          this.getCategory();
        });
    },
    // lib
    showMultiple(poster) {
      this.index = 0;
      this.imgs = [];
      poster.image.forEach((image) => {
        this.imgs.push(this.env + image.poster_file_path);
      });
      this.show();
    },
    show() {
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
  },
};
</script>